import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";


import SuccessPopupModal from "../../components/SuccessPopupModal";
import { useAuth } from "../../../Context/AuthContext";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import { GetProjectCatLookup } from "../../../Services/Project Category/ProjectCategoryApi";
import { addUpdateProject, GetProjectModelData } from "../../../Services/Project/ProjectApi";
import { isVideoSource } from "../../../mediaHelpers";

const MAX_IMAGE_SIZE_BYTES = 200 * 1024; // 200KB
const MAX_VIDEO_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

const ProjectCategorAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { setLoader, user } = useAuth();
  const [projectCatOption, setProjectCatOption] = useState([]);

  const [projectObj, setProjectObj] = useState({
    projectKeyID:null,
    projectCatKeyID:null,
    projectName:null,
    projectImage:null


  });



  useEffect(() => {
    // debugger
    if (modelRequestData?.Action === "Update") {
      if (modelRequestData?.ProjectKeyID !== null) {
        GetBlogModalData(modelRequestData.ProjectKeyID);
      }
    }
  }, [modelRequestData?.Action]);

  useEffect(()=>{
    GetRoleTypeLookupListData()
  },[modelRequestData.Action])

  const AddCustomerBtnClick = async () => {
    // debugger
    let isValid = false;

    if (
      projectObj.projectCatKeyID === null ||
      projectObj.projectCatKeyID === undefined ||
      projectObj.projectCatKeyID === "" ||
      projectObj.projectName === null ||
      projectObj.projectName === undefined ||
      projectObj.projectName === "" ||
      projectObj.projectImage === null ||
      projectObj.projectImage === undefined ||
      projectObj.projectImage === "" 
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
    
      projectKeyID: projectObj.projectKeyID,
      projectCatKeyID: projectObj.projectCatKeyID,
      projectName: projectObj.projectName,
      projectImage: projectObj.projectImage,
    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };



  
  const GetRoleTypeLookupListData = async () => {
    
    try {
      const response = await GetProjectCatLookup(); // Ensure this function is imported correctly

      if (response?.data?.statusCode === 200) {
        const roleTypeLookupList = response?.data?.responseData?.data || [];

        const formattedGalleryList = roleTypeLookupList.map((gallery) => ({
          value: gallery.ProjectCatKeyID,
          label: gallery.ProjectCatName
        }));

        setProjectCatOption(formattedGalleryList); // Make sure you have a state setter function for IVR list
      } else {
        console.error('Failed to fetch gallery Type lookup list:', response?.data?.statusMessage || 'Unknown error');
      }
    } catch (error) {
      console.error('Error fetching gallery Type lookup list:', error);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = "/addUpdateProject"; // Default URL for Adding Data

      const response = await addUpdateProject(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null ||
              modelRequestData.Action === undefined
              ? "Project Added Successfully!"
              : " Project Updated Successfully!"
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const isVideo = file.type.startsWith("video/");
      const isImage = file.type.startsWith("image/");

      if (!isVideo && !isImage) {
        alert("Only image or video files are allowed.");
        e.target.value = "";
        return;
      }
      if (isImage && file.size > MAX_IMAGE_SIZE_BYTES) {
        alert("Image size should be 200KB or less.");
        e.target.value = "";
        return;
      }
      if (isVideo && file.size > MAX_VIDEO_SIZE_BYTES) {
        alert("Video size should be 5MB or less.");
        e.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setProjectObj((prev) => ({
          ...prev,
          [fieldName]: reader.result, // set base64
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (fieldName) => {
    setProjectObj((prev) => ({
      ...prev,
      [fieldName]: null,
    }));
  };
  const GetBlogModalData = async (id) => {
    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await GetProjectModelData(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        console.log(data, "dsadas324r");
        const ModelData = data.data.responseData.data; // Assuming data is an array
        console.log(ModelData.Title, "dsaiygd9s7a6ydsadsa");

        setProjectObj({
          ...projectObj,
          projectCatKeyID: ModelData.ProjectCatKeyID,
          projectKeyID: ModelData.ProjectKeyID,
          projectName: ModelData.ProjectName,
          projectImage: ModelData.projectImage,
          
        });
      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error("Error fetching data: ", data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error in Customer : ", error);
    }
  };

  console.log(projectObj.Title, "kdjsgauhydsa");

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  const handleDescriptionChange = (htmlContent) => {
    setProjectObj((obj) => ({
      ...obj,
      blogDescription: htmlContent,
    }));
  };

  const handleDateChange = (event) => {
    const selectedDate = event.target.value; // Gets the publishDate in "YYYY-MM-DD" format
    setProjectObj((prev) => ({
      ...prev,
      publishDate: selectedDate,
    }));
  };
  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal
        size="md"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <>
            <h4 className="text-center text-dark project-main-mode">
              {modelRequestData?.Action !== null
                ? "Update Project"
                : modelRequestData?.Action === null
                ? "Add Project"
                : ""}
            </h4>
          </>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className>
            <div className>
              <div className="col-12 col-md-12 mb-2 projectCatModal">
                <div >
                  <label htmlFor="clientName ">
                 Select Project Category 
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
  options={projectCatOption}
  value={projectCatOption.find(option => option.value === projectObj.projectCatKeyID) || null}
  onChange={(selectedOption) => {
    setProjectObj(prev => ({
      ...prev,
      projectCatKeyID: selectedOption?.value || null
    }));
  }}
/>

                  {error &&
                  (projectObj.projectCatKeyID === null ||
                    projectObj.projectCatKeyID === undefined ||
                    projectObj.projectCatKeyID === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                  Project Title
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Enter Category Name"
                    aria-describedby="Employee"
                    value={projectObj.projectName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setProjectObj((prev) => ({
                        ...prev,
                        projectName: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                  (projectObj.projectName === null ||
                    projectObj.projectName === undefined ||
                    projectObj.projectName === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <label className="form-label">Project Image/Video:
                <p className="small">Note:-(Image upto 200kb or Video upto 5mb) </p>
                </label>
                {projectObj.projectImage ? (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    {isVideoSource(projectObj.projectImage) ? (
                      <video
                        src={projectObj.projectImage}
                        controls
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    ) : (
                      <img
                        src={projectObj.projectImage}
                        alt="Feature Preview"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    )}
                    <button
                      type="button"
                      onClick={() => handleRemoveImage("projectImage")}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "rgba(255,255,255,0.8)",
                        border: "none",
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: "bold",
                        padding: "2px 8px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*,video/*"
                    onChange={(e) => handleImageChange(e, "projectImage")}
                    className="form-control"
                  />
                )}
              </div>
            </div>

            {/* <div className="row"> */}
          </div>

          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
            style={{
              color: "white",
              backgroundColor: "#blue",
              borderColor: "#f08143",
            }}
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default ProjectCategorAddUpdateModal;
 